import React from 'react';

const NoteBox = ({title,color}) => {
    return (
        <div className='note-box' style={{backgroundColor:color}}>
            {title}
        </div>
    );
};

export default NoteBox;